import {
  fetchCityToCityStandardExport,
  fetchCityToCityStandardOperationConfig,
  fetchCityToCityStandardPage,
  fetchCityToCityStandardSaveOperationConfig,
} from '@/services/cityToCityStandard';

const normalizeOperationDurationConfig = (data) => {
  // 配置接口可能直接返回数字，也可能返回对象，这里统一转成弹窗表单可消费的结构。
  if (data && typeof data === 'object') {
    return data;
  }
  if (data === null || data === undefined || data === '') {
    return { time: undefined };
  }
  return { time: data };
};

export default {
  namespace: 'cityToCityStandardTable',
  state: {
    searchParams: {},
    list: [],
    total: 0,
    areaTypeOptions: [],
    operationDurationConfig: {
      time: undefined,
    },
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      const result = yield call(fetchCityToCityStandardPage, payload);
      yield put({
        type: 'updateState',
        payload: {
          searchParams: payload || {},
          list: result?.data?.rows || [],
          total: result?.data?.total || 0,
        },
      });
      return result;
    },
    *exportData({ payload }, { call }) {
      return yield call(fetchCityToCityStandardExport, payload);
    },
    *fetchOperationDurationConfig(_, { call, put }) {
      const result = yield call(fetchCityToCityStandardOperationConfig);
      yield put({
        type: 'updateState',
        payload: {
          operationDurationConfig: normalizeOperationDurationConfig(result?.data),
        },
      });
      return result;
    },
    *saveOperationDurationConfig({ payload }, { call, put }) {
      const result = yield call(fetchCityToCityStandardSaveOperationConfig, payload);
      if (result?.code === 1) {
        yield put({
          type: 'updateState',
          payload: {
            operationDurationConfig: payload,
          },
        });
      }
      return result;
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
